import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/qtFm',
    name: 'qtFm',
	component: () => import('../views/home.vue'),
	meta:{ title: '蜻蜓FM会员兑换' }
  },
  {
    path: '/checkExCode',
    name: 'checkExCode',
	component: () => import('../views/checkExCode.vue'),
	meta:{ title: '查看兑换码' }
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes
})

//修改title
router.afterEach((to, from) => {
    let title = to.meta.title;
	if(!!title){
		document.title = title;
	}
})

export default router
